import { DashboardsApi } from "apis/DashboardsApi";
import { Title } from "components";
import { AdminDashboard } from "models/storeModels/DashboardData";
import StatisticsWidget from "pages/dashboard/Widgets/Statistics/StatisticsWidget";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

export function Dashboard() {

    const [dashboardData, setDashboardData] = useState<AdminDashboard[]>([]);

    useEffect(() => {
        DashboardsApi.AdminStats().then((response) => {
            setDashboardData(response.data.data);
        });
    }, [])

    return (
        <div className="d-flex flex-column">
            <Title pageTitle="Dashboard" />
            <Card className="mt-3 d-flex vertical-align-center">
                <Card.Header>
                    <span className="d-flex justify-content-center">
                        <p className="mb-0 fs-4 fw-bold">Build Information</p>
                    </span>
                    <hr className="mt-1 mb-1 border-1 mx-1" />
                    <Row>
                        <Col xs={6}>
                            <div className="d-flex"><i className="mdi mdi-source-commit me-1 fs-4" /><p className="mb-0" style={{ lineHeight: "1.75rem" }}><strong>Commit:</strong> '4bb0756239f094863789eb24ebeaa04fb0f0533b'</p></div>
                        </Col>
                        <Col xs={6}>
                            <div className="d-flex"><i className="mdi mdi-wrench me-1 fs-4" /><p className="mb-0" style={{ lineHeight: "1.75rem" }}><strong>Build:</strong> '862'</p></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <div className="d-flex"><i className="mdi mdi-source-branch me-1 fs-4" /><p className="mb-0" style={{ lineHeight: "1.75rem" }}><strong>Branch:</strong> </p></div>
                        </Col>
                        <Col xs={6}>
                            <div className="d-flex"><i className="mdi mdi-calendar me-1 fs-4" /><p className="mb-0" style={{ lineHeight: "1.75rem" }}><strong>Build Date:</strong> 06/05/2025 08:23:22 PM</p></div>
                        </Col>
                    </Row>
                    <div>
                        'refs/heads/master'
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row style={{rowGap: '10px'}}>
                        {dashboardData.map((data, index) => (
                            <Col md={4} xl={4} key={index}>
                            <StatisticsWidget
                                icon="mdi mdi-account-multiple"
                                title={data.title}
                                key={data.key}
                                stats={data.statistic ?? 0}
                                rightPanel={data.rightPanel && Object.keys(data.rightPanel).map((k, i) => 
                                    ({ name: k, value: data.rightPanel![k] })
                                )}
                                leftPanel={data.leftPanel && Object.keys(data.leftPanel).map((k, i) => 
                                    ({ name: k, value: data.leftPanel![k] })
                                )}
                                trend={data.trend}
                            />
                        </Col>
                        ))}                        
                    </Row>
                </Card.Body>
            </Card>
        </div >
    );
}
